export default __webpack_public_path__ + "static/media/more_info_corner2_01.5bd4c8c9.png";